import React, { useState, createContext } from "react";
import { FilterState } from "../types/type";
import { registerLocale } from "react-datepicker";
import pt from "date-fns/locale/pt";

registerLocale("pt", pt);
let startDateDaysAgo = new Date()
startDateDaysAgo.setDate(startDateDaysAgo.getDate() - 7);

export const initState = { 
    filterData: null,
    selectedPort: undefined,
    selectedCategory: undefined,
    selectedCategorySubtypes: undefined,
    selectedType: undefined,
    selectedStartDate: startDateDaysAgo,
    selectedEndDate: (new Date())
}

export const FilterContext = createContext<FilterState>(initState);
export const FilterDispatchContext = createContext<Function>(() => null);

export default (props) => {
    const [filterState, setFilterState] = useState<FilterState>(initState) 

    return (
        <FilterContext.Provider value={filterState}>
             <FilterDispatchContext.Provider value={setFilterState}>
                {props.children}
             </FilterDispatchContext.Provider>
        </FilterContext.Provider>
    );
  }